export default "__VITE_ASSET__C$6DQwTF__"